export function isEmailValid(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

//Allows Special Characters and Space
export function isValidName(name) {
    var re  = /^[A-Za-z ][A-Za-z0-9!@#$%^&* ]*$/ ;
    return re.test(String(name));
}

export function handleServerError(err){

    let error = '';

    if (err.responseJSON) {
        const ErrorJSON = err.responseJSON
        if (ErrorJSON.errors) {
            for(var errKey in ErrorJSON.errors)
                error += ErrorJSON.errors[errKey] + "<br/>";
        }
        else if (ErrorJSON.Message) {
            error = ErrorJSON.Message;
        }
        else if (ErrorJSON.ModelState) {
            for(var key in ErrorJSON.ModelState)
                error += ErrorJSON.ModelState[key].join(" ");
        }
        else if (ErrorJSON.error_description) {
            error = ErrorJSON.error_description;
        }
    }
    else if (err.responseText) error = err.responseText;
    else if (err.Message) error = err.Message;
    else if (err) error = err+"";

    return error;
}
